import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/pg.png";
import projImg2 from "../assets/img/fitness_track_height_plus60_total.png";
import projImg3 from "../assets/img/qr.png";
import projImg4 from "../assets/img/Screenshot 2025-11-14 214955.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Secure Password Generator",
      description: "A zero-dependency application featuring customizable entropy and real-time password strength validation using HTML5, CSS, and JS.",
      imgUrl: projImg1,
      link: "https://raushan950.github.io/password-producer/",
    },
    {
      title: "Fitness & Nutrition Tracker",
      description: "A robust MERN stack platform (React, Node.js, Express, MongoDB) for users to seamlessly log, monitor, and visualize their daily fitness goals.",
      imgUrl: projImg2,
      link: "https://github.com/raushan950/FitnessTrack",
    },
    {
      title: "Dynamic QR Code Generator",
      description: "A fast, ReactJS-based utility that dynamically converts text and URLs into downloadable, high-fidelity QR codes on the edge.",
      imgUrl: projImg3,
      link: "https://raushan950.github.io/basic-project/",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
